import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { FolderOpen, Tag, Star, Mail } from 'lucide-react';
import { adminAPI } from '../../utils/api';

const AdminDashboard = () => {
  const [stats, setStats] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadStats();
  }, []);

  const loadStats = async () => {
    try {
      const response = await adminAPI.getStats();
      setStats(response.data);
    } catch (error) {
      console.error('Error loading stats:', error);
    } finally {
      setLoading(false);
    }
  };

  const statCards = [
    { label: 'Total Projects', value: stats?.total_projects || 0, icon: FolderOpen, color: 'text-primary' },
    { label: 'Featured Projects', value: stats?.featured_projects || 0, icon: Star, color: 'text-yellow-500' },
    { label: 'Categories', value: stats?.total_categories || 0, icon: Tag, color: 'text-blue-500' },
    { label: 'Contact Messages', value: stats?.recent_contacts || 0, icon: Mail, color: 'text-green-500' }
  ];

  return (
    <div data-testid="admin-dashboard">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
      >
        <h1 className="text-4xl font-bold font-['Syne'] mb-8" data-testid="dashboard-title">Dashboard</h1>

        {loading ? (
          <div className="text-center py-20" data-testid="dashboard-loading">
            <p className="text-muted-foreground">Loading stats...</p>
          </div>
        ) : (
          <div className="grid grid-cols-1 md:grid-cols-4 gap-6" data-testid="stats-grid">
            {statCards.map((stat, index) => {
              const Icon = stat.icon;
              return (
                <div
                  key={index}
                  className="bg-card border border-white/10 p-6 rounded-lg"
                  data-testid={`stat-card-${index}`}
                >
                  <div className="flex items-center justify-between mb-4">
                    <Icon className={stat.color} size={24} />
                  </div>
                  <div className="text-3xl font-bold mb-2" data-testid={`stat-value-${index}`}>
                    {stat.value}
                  </div>
                  <div className="text-sm text-muted-foreground" data-testid={`stat-label-${index}`}>
                    {stat.label}
                  </div>
                </div>
              );
            })}
          </div>
        )}
      </motion.div>
    </div>
  );
};

export default AdminDashboard;
